export default {
  state: {
    dateTimePicker: {
      show: false,
      selectedDate: null,
      calendar: {
        disabled: false
      },
      forPickupDate: false,
      customPickupDateDefault: '',
      suggestedTime: ''
    }
  },
  mutations: {
    showDateTimePicker (state) { state.dateTimePicker.show = true },
    hideDateTimePicker (state) { state.dateTimePicker.show = false },
    setDatePickerSelectedDate (state, value) { state.dateTimePicker.selectedDate = value },
    setDatePickerDisabled (state, value) { state.dateTimePicker.calendar.disabled = value },
    setForPickupDate (state, value) { state.dateTimePicker.forPickupDate = value },
    setCustomPickupDateDefault (state, value) { state.dateTimePicker.customPickupDateDefault = value },
    setSuggestedTime (state, value) { state.dateTimePicker.suggestedTime = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/service-selection/datetime-picker.js